<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row no-gutters>
      <label class="v-label theme--light mb-3 d-block">{{ $t('qr_accuracy')}}</label>
       <v-col class="pa-2 d-flex flex-row align-center" cols="12">
        <v-img 
          src="/media/img/p_L.svg" 
          max-width="27" 
          height="27" 
          contain 
          class="mx-2"
        />

        <v-slider
          v-model="computedValue.qrOptions.typeNumber"
          max="32"
          min="0"
          thumb-label
          track-color="grey"
          hide-details
          class="mx-2 mt-0"
          @input="$emit('update', true)"
        >
          <template v-slot:thumb-label="{ value }">
            <div
              class="d-flex align-center justify-center"
              style="
                width: 20px;
                height: 20px;
                background-color: rgba(12, 15, 26, 0.7);
                border-radius: 50%;
              "
            >
              {{ value }}
            </div>
          </template>
        </v-slider>

        <v-img 
          src="/media/img/p_H.svg" 
          max-width="27" 
          height="27" 
          contain 
          class="mx-2"
        />
      </v-col>

              <!-- بخش گرافیکی سطح اصلاح خطا با SVG -->
        <v-col class="pa-2 mt-3" cols="12">
          <label class="v-label theme--light mb-3 d-block">{{ $t('error_correction_level') }}</label>
          <v-item-group
            v-model="correctionLevelIndex"
            class="mt-2"
            mandatory
          >
            <v-row>
              <v-col
                v-for="(item, i) in correctionLevels"
                :key="i"
                cols="6"
                sm="3"
              >
                <v-item v-slot="{ active, toggle }">
                  <v-card 
                    :class="['d-flex flex-column align-center pa-4 text-center transition-swing', active ? 'active-level-card elevation-10' : 'inactive-level-card elevation-8']"
                    height="100%"
                    @click="toggle"
                  >
                    <!-- استفاده از CSS Mask برای رندر SVG و تغییر رنگ آن -->
                    <div
                      class="svg-mask-icon mb-3 "
                      :class="active ? 'bg-white' : 'bg-dark'"
                      :style="{
                        '-webkit-mask-image': `url(/media/img/${item.level}.svg)`,
                        'mask-image': `url(/media/img/${item.level}.svg)`,
                        'border-radius': '0px'
                      }"
                    ></div>
                    <div class="d-flex flex-row">
                    <v-chip small class="caption mx-1 pa-1">

                      {{ item.percent }}%</v-chip>
                    <div class="font-weight-bold pa-1">Level {{ item.level }}</div>

                    </div>
                  </v-card>
                </v-item>
              </v-col>
            </v-row>
          </v-item-group>
        </v-col>

      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
export default {
  name: "qrCodeOptions",

  props: {
    value: Object,
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "qrCodeOptions",
      // مقادیر level دقیقاً مطابق نام فایل‌های SVG شما تنظیم شده است (L, M, Q, H)
      correctionLevels: [
        { level: "L", percent: 7 },
        { level: "M", percent: 15 },
        { level: "Q", percent: 25 },
        { level: "H", percent: 30 },
      ],
    };
  },

  created() {
    this.computedValue.qrOptions.mode = 'Byte';
    this.$emit('update', true);
  },

  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },

  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    correctionLevelIndex: {
      get() {
        const level = this.computedValue.qrOptions.errorCorrectionLevel;
        return this.correctionLevels.findIndex(item => item.level === level);
      },
      set(index) {
        if (index >= 0 && index < this.correctionLevels.length) {
          this.computedValue.qrOptions.errorCorrectionLevel = this.correctionLevels[index].level;
          this.$emit("update", true);
        }
      },
    },
  },
};
</script>

<style scoped>
.imgaccuracy{
  width: 30px !important;
  height: 30px !important;

}
.rowinfo {
  display: flex;
  align-items: center;
}
.contentinfo {
  flex-grow: 1;
}
.buttoninfo {
  margin-left: 8px;
}

.active-level-card {
  background-color: #0b143a !important; 
  color: white !important;
  border-radius: 16px !important; 
  cursor: pointer;
  box-shadow: 0 6px 12px rgba(11, 20, 58, 0.6) !important;
  border: 2px solid transparent;
}

.inactive-level-card {
  background-color: #ffffff !important;
  color: #000000 !important;
  border-radius: 16px !important;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35) !important;
  border: 2px solid transparent; 
}

.inactive-level-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.54) !important;
}

.svg-mask-icon {
  width: 70px;
  height: 70px;
  -webkit-mask-size: contain;
  -webkit-mask-position: center;
  -webkit-mask-repeat: no-repeat;
  mask-size: contain;
  mask-position: center;
  mask-repeat: no-repeat;
  transition: background-color 0.3s ease;
}

.bg-white {
  background-color: #ffffff; /* رنگ آیکون در حالت انتخاب */
}

.bg-dark {
  background-color: #1a1a1a; /* رنگ آیکون در حالت عادی */
}
</style>
